import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";
import React, { FunctionComponent } from "react";

export const ReferralIcon: FunctionComponent<SvgIconProps> = (props) => (
	<SvgIcon
		viewBox="0 0 24 24"
		{...props}
	>
		<path
			clipRule="evenodd"
			d="M8.50014 4.5V6.5H16.09L4.49914 18.09L5.90912 19.5L17.5 7.91V15.5H19.5V4.5H8.50014Z"
			fill="#79818F"
			fillRule="evenodd"
		/>
	</SvgIcon>
);

export default ReferralIcon;
